export default "__VITE_ASSET__DaYFVZpp__"